import { useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import API, { commonApiInvoker } from "@api/api"
import { Image, message } from "antd"
import { forwardRef } from "react"
import * as _ from "underscore";
import ExtraRender from "./components/ExtraRender"
import ImagePreviewRender from "./components/ImagePreviewRender"
import styles from "./index.module.scss"

const ImagePreviewWithLabel = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        handlePreview: ({current, dataSource}) => {
            const items = dataSource.map(item => item.skuList).flat().map(item => item.imageList).flat()
            setImageItems(items)
            setDataSource(dataSource)
            setCurrent(current)
            setVisible(true)
        }
    }))

    const isMultipleRef = useRef(false)
    const [multiple, setMultiple] = useState(false) // 批量浏览模式
    const multipleRef = useRef() // 批量模式dom
    const [readonly] = useState(props.readonly)
    const [visible, setVisible] = useState(false)
    const [poseList, setPoseList] = useState([])
    
    const [dataSource, setDataSource] = useState([]) // 原始数据
    const [imageItems, setImageItems] = useState([]) // 全部的交付图
    const imageItemsRef = useRef(imageItems) // 解决getLabels闭包捕获陈旧imageItems的问题
    useEffect(() => {
        imageItemsRef.current = imageItems
    }, [imageItems])

    const [current, setCurrent] = useState() // 定位

    // 决定pre/next按钮的是否可切换
    const currentIndex = useMemo(() => {
        if (!current) return -1
        if (multiple) {
            const imageId = current.imageId
            return imageItems.findIndex(item => item.imageId == imageId)
        } else {
            const imageId = current.imageId
            return imageItems.findIndex(item => item.imageId == imageId)
        }
    }, [multiple, imageItems, current])

    // 单spu浏览模式下左下角sku列表
    // 批量浏览模式无效
    const skuItems = useMemo(() => {
        if (!current) return []
        if (multiple) {
            return []
        } else {
            const spuId = current.spuId
            const spuItem = dataSource.find(item => item.spuId == spuId)
            return spuItem?.skuList || []
        }
    }, [dataSource, multiple, current])

    // 单图浏览模式所选项
    const item = useMemo(() => {
        return imageItems[currentIndex]
    }, [imageItems, currentIndex])
    // 批量浏览模式所选项
    const [currentIndexs, setCurrentIndexs] = useState([])
    const items = useMemo(() => {
        return currentIndexs.map(index => imageItems[index])
    }, [imageItems, currentIndexs])
    useEffect(() => {
        if (item && !item.read) {
            setImageItems(pre => {
                const temp = [...pre]
                const obj = temp.find(i => i.imageId == item.imageId)
                if (!obj) return [...temp]
                obj.read = true
                return [...temp]
            })
            props.onRead && props.onRead(item.imageId, item)
        }
    }, [item])
    useEffect(() => {
        const notReadItems = items.filter(item => item && !item.read)
        if (notReadItems.length > 0) {
            setImageItems(pre => {
                const temp = [...pre]
                for (let item of notReadItems) {
                    const obj = temp.find(i => i.imageId == item.imageId)
                    if (!obj) continue
                    obj.read = true
                    props.onRead && props.onRead(item.imageId, item)
                }
                return [...temp]
            })
        }
    }, [items])

    // 切换不同的sku
    // 批量浏览模式无效
    const handleSelectSku = (skuItem) => {
        // OPS Only
        // 不支持切换至下一个sku图查看
        // if (skuItem.skuId != current.skuId) message.warning("不支持切换至其他sku图查看")
        // return false

        // Master Only
        setCurrent(pre => {
            const newSkuId = skuItem.skuId
            const newSpuId = skuItem.spuId
            if (newSkuId == pre.skuId) return pre
            else {
                const imageItem = imageItems.find(item => item.skuId == newSkuId)
                return {
                    spuId: newSpuId,
                    skuId: newSkuId,
                    imageId: imageItem?.imageId
                }
            }
        })
    }

    // 下一个/上一个
    const handleChange = (current, prevCurrent) => {
        if (isMultipleRef.current) {
            if (!multipleRef.current) return false
            if (current > prevCurrent) {
                multipleRef.current.goNext()
            } else {
                multipleRef.current.goPrevious()
            }
        } else {
            // OPS Only 不支持切换至下一个sku图查看
            const item = imageItems[current]
            // const prevItem = imageItems[prevCurrent]
            // if (item?.skuId != prevItem?.skuId) return
            setCurrent({
                spuId: item?.spuId,
                skuId: item?.skuId,
                imageId: item?.imageId,
            })
        }
    }
    // 切换浏览模式
    const currentBak = useRef()
    const handleMultiple = (bool) => {
        // OPS Only 从模式2切换回模式1时，默认回到切换至模式2前，正在查看的图
        // if (bool) {
        //     currentBak.current = {...current}
        // } else {
        //     setCurrent(currentBak.current)
        // }
        // Master Only
        if (!bool) {
            const firstFixedItem = imageItems.find(item => item.fixed) || imageItems[0]
            setCurrent({
                spuId: firstFixedItem?.spuId,
                skuId: firstFixedItem?.skuId,
                imageId: firstFixedItem?.imageId,
            })
        }
        // 清除fixed数据
        if (!bool) {
            setImageItems(pre => {
                const temp = [...pre]
                temp.forEach(item => item.fixed = false)
                return temp
            })
        }
        isMultipleRef.current = bool
        setMultiple(bool)
    }

    const handleUpdateLabel = (imageId, labels, item) => {
        setImageItems(pre => {
            const temp = [...pre]
            const obj = temp.find(i => i.imageId == imageId)
            if (!obj) return [...temp]
            obj.annotations = [...labels]
            return [...temp]
        })
        props.onLabel && props.onLabel(imageId, labels, item)
    }
    const handleUpdateDeliveryStatus = (imageId, status) => {
        setImageItems(pre => {
            const temp = [...pre]
            const obj = temp.find(i => i.imageId == imageId)
            if (!obj) return [...temp] 
            // 标记状态改变时，重置deliverySubmit为false
            if (obj.deliveryStatus != status) obj.deliverySubmit = false
            obj.deliveryStatus = status
            return [...temp]
        })
    }
    const handlePrevious = () => {
        setCurrent(pre => {
            if (!pre) return pre
            const index = imageItems.findIndex(item => item.imageId == pre.imageId)
            if (item == -1 || index == 0) return pre
            else {
                const item = imageItems[index - 1]
                return {
                    spuId: item.spuId,
                    skuId: item.skuId,
                    imageId: item.imageId,
                }
            }
        })
    }
    const handleNext = () => {
        setCurrent(pre => {
            if (!pre) return pre
            const index = imageItems.findIndex(item => item.imageId == pre.imageId)
            if (item == -1 || index == imageItems.length - 1) return pre
            else {
                const item = imageItems[index + 1]
                return {
                    spuId: item.spuId,
                    skuId: item.skuId,
                    imageId: item.imageId,
                }
            }
        })
    }
    const imageRender = () => {
        const currentItem = []
        // 源素材
        if (item?.inputImage) currentItem.push({
            name: '源素材',
            url: item?.inputImage,
            readonly: true,
            defaultOpen: "left",
        })
        // 参考图
        if (item?.refImage) {
            currentItem.push({
                name: '参考图',
                url: item?.refImage,
                readonly: true,
            })
        } else {
            const poseKey = item?.poseKey
            const poseUrl = item?.poseUrl || (poseList.find(item => item?.name == poseKey)?.imageUrl)
            if (poseUrl) currentItem.push({
                name: '参考图',
                // extraName: poseKey, // OPS Only
                url: poseUrl,
                readonly: true,
            })
        }
        // 搭配图
        if (item?.matchClothImage) currentItem.push({
            name: '搭配图',
            url: item?.matchClothImage,
            readonly: true,
            defaultOpen: "right",
        })
        // 上次质检图
        const preImage = item?.prevImage
        if (preImage && preImage.image) {
            currentItem.push({
                name: '质检图',
                url: preImage.image,
                annotations: preImage.annotations || [],
                readonly: true,
                fixed: true,
                defaultOpen: "right",
            })
        }
        // 输出图
        // 通过ref获取最新的imageItems，避免闭包捕获陈旧状态
        const getLabels = () => {
            const item = imageItemsRef.current[currentIndex]
            return item?.annotations || []
        }
        const extraRender = () => (
            <ExtraRender
                current={currentIndex}
                total={imageItems.length}
                imageId={item?.imageId}
                deliveryId={item?.deliveryId}
                labels={item?.annotations || []}
                getLabels={getLabels}
                defaultPass={item?.deliveryStatus == 3 ? false : item?.deliveryStatus == 2 ? true : null} // 1已交付 2 已交付通过 3 已交付不通过
                defaultDisabled={(item?.deliverySubmit && (item?.deliveryStatus == 2 || item?.deliveryStatus == -1)) ? true : false}
                defaultCancel={item?.deliveryStatus == -1 ? true : false}
                onPrevious={handlePrevious}
                onNext={(pass, ignorePass=false) => {
                    if (!ignorePass) {
                        if (pass) handleUpdateLabel(item.imageId, []) // 通过时，要将标注清空
                        handleUpdateDeliveryStatus(item.imageId, pass ? 2 : 3) // 更新deliveryStatus
                    }
                    handleNext()
                }}
                onClose={() => {
                    setVisible(false);
                    props.onClose && props.onClose()
                }}
            />
        )
        currentItem.push({
            name: "交付图",
            url: item?.output,
            annotations: item?.annotations || [],
            readonly: (item?.deliverySubmit && item?.deliveryStatus == 2) ? true : false, // Master Only
            // readonly: readonly, // OPS Only
            fixed: true, // 固定
            downloadable: false, // 可下载
            defaultOpen: "middle",
            onLabel: (labels) => handleUpdateLabel(item.imageId, labels, item),
            extraRender: extraRender
        })
        
        return (
            <ImagePreviewRender
                key={item?.imageId}
                current={current}
                currentItem={currentItem}
                skuItems={skuItems}
                onSelectSku={handleSelectSku}
                onMultiple={handleMultiple}
            />
        )
    }

    // 钉住某张图
    const handleFixed = (imageId) => {
        setImageItems(pre => {
            const temp = [...pre]
            const obj = temp.find(i => i.imageId == imageId)
            if (!obj) return [...temp]
            if (!obj.fixed) {
                const fixedItems = temp.filter(item => item.fixed)
                if (fixedItems.length >= 2) {
                    message.warning("最多同时固定两张图")
                    return [...temp]
                }
            }
            obj.fixed = !obj.fixed
            return [...temp]
        })
    }
    const handleCurrentChange = (item, indexs) => {
        setCurrentIndexs(pre => {
            const diff = indexs.filter(index => !pre.includes(index))
            if (diff.length > 0) return indexs
            else return pre
        })
        setCurrent(pre => {
            if (pre?.imageId == item?.imageId) return pre
            return {
                spuId: item?.spuId,
                skuId: item?.skuId,
                imageId: item?.imageId,
            }
        })
    }
    const imageRenderMultiple = () => {
        const _items = imageItems.map((item, index) => {
            // 通过ref获取最新的imageItems，避免闭包捕获陈旧状态
            const getLabels = () => {
                const latestItem = imageItemsRef.current.find(i => i.imageId === item?.imageId)
                return latestItem?.annotations || []
            }
            const extraRender = () => (
                <ExtraRender
                    imageId={item?.imageId}
                    deliveryId={item?.deliveryId}
                    labels={item?.annotations || []}
                    getLabels={getLabels}
                    defaultPass={item?.deliveryStatus == 3 ? false : item?.deliveryStatus == 2 ? true : null} // 1已交付 2 已交付通过 3 已交付不通过
                    defaultDisabled={(item?.deliverySubmit && (item?.deliveryStatus == 2 || item?.deliveryStatus == -1)) ? true : false}
                    defaultCancel={item?.deliveryStatus == -1 ? true : false}
                    onOk={(pass, ignorePass=false) => {
                        if (!ignorePass) {
                            if (pass) handleUpdateLabel(item.imageId, []) // 通过时，要将标注清空
                            handleUpdateDeliveryStatus(item.imageId, pass ? 2 : 3) // 更新deliveryStatus
                        }
                    }}
                />
            )
            return {
                index: index,
                spuId: item.spuId,
                skuId: item.skuId,
                imageId: item.imageId,
                name: "交付图",
                url: item?.output,
                annotations: item?.annotations || [],
                readonly: (item?.deliverySubmit && item?.deliveryStatus == 2) ? true : false, // Master Only
                // readonly: readonly, // OPS Only
                fixed: item.fixed, // 固定
                downloadable: false, // 可下载
                onLabel: (labels) => handleUpdateLabel(item.imageId, labels, item),
                extraRender: extraRender
            }
        })

        return (
            <ImagePreviewRender.Multiple
                key="multiple"
                ref={multipleRef}
                currentIndex={currentIndex}
                imageItems={_items}
                onMultiple={handleMultiple}
                onFixed={handleFixed}
                onCurrentChange={handleCurrentChange}
            />
        )
    }

    return (
        <Image.PreviewGroup
            items={imageItems}
            preview={{
                focusTrap: false,
                rootClassName: styles.rootClassName,
                visible,
                current: currentIndex,
                destroyOnClose: true,
                imageRender: multiple ? imageRenderMultiple : imageRender,
                countRender: () => null,
                toolbarRender: () => null,
                onChange: handleChange,
                onVisibleChange: (visible) => {
                    setVisible(visible)
                    if (!visible) {
                        isMultipleRef.current = false
                        setMultiple(false)
                        props.onClose && props.onClose()
                    }
                }
            }}
        >
        </Image.PreviewGroup>
    )
})

export default ImagePreviewWithLabel